export default __webpack_public_path__ + "static/media/c_plus_plus.fd1f9f60.svg";